import GamesRow from './Row'

export default GamesRow
